/* eslint-disable max-len */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';

import { BaseSearchBarModule } from '@shared/base-search-bar/base-search-bar.module';
import { SwipeUpModule } from '@ux/components/swipe-up/swipe-up.module';
import { SearchBarModule } from '@search-bar/search-bar.module';
import { GlobalPipesModule } from '@app/pipes/global-pipes.module';
import { ButtonDsComponent } from '@design-system/components/molecules/button/button.component';
import { FixedSurfaceModule } from '@ux/components/fixed-surface/fixed-surface.module';
import { InputTextDsComponent } from '@design-system/components/molecules/input-text/input-text.component';
import {
  ActivitiesSearchBarContainer
} from '@activities/activities-search-bar/activities-search-bar.container';
import { TypographyDsComponent } from '@design-system/components/atoms/typography/typography.component';
import { IconDsComponent } from '@design-system/components/atoms/icon/icon.component';
import { ActivitiesAdBannerComponent } from '@activities/activities-search-bar/components/activities-ad-banner/activities-ad-banner.component';

@NgModule({
  declarations: [
    ActivitiesSearchBarContainer,
    ActivitiesAdBannerComponent,
  ],
  imports: [
    CommonModule,
    TranslocoModule,
    BaseSearchBarModule,
    GlobalPipesModule,
    SwipeUpModule,
    SearchBarModule,
    ButtonDsComponent,
    FixedSurfaceModule,
    InputTextDsComponent,
    TypographyDsComponent,
    IconDsComponent,
  ],
  exports: [
    ActivitiesSearchBarContainer,
  ],
})
export class ActivitiesSearchBarModule { }
